import { triggerSnackbar } from "../Services/NotificationService";
import CryptoJS from "crypto-js";
import { ImageUrl } from "../ApiService/Axios/Index";
export const colors = {
  green: "var(--brand-color)",
  red:"#FF4141"
};

export const Makelabel = (name) => {
  return (
    <p className="text-darktext font-bold  font-inter capitalize text-[13px]">{name}</p>
  );
};

export const MakeError = (name) => {
  return (
    <p className="text-red-600 mt-2 px-2 font-inter capitalize text-[13px]">{name}</p>
  );
};


// Get an item from local storage
export const getLocalStorageItem = (key) => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error getting ${key} from local storage: ${error}`);
      return null;
    }
  };
  
  // Set an item in local storage
  export const setLocalStorageItem = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting ${key} in local storage: ${error}`);
    }
  };
  
  // Remove an item from local storage
  export const removeLocalStorageItem = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing ${key} from local storage: ${error}`);
    }
  };

// Get an item from session storage
export const getSessionStorageItem = (key) => {
  try {
    const item = window.sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error getting ${key} from session storage: ${error}`);
    return null;
  }
};

// Set an item in session storage
export const setSessionStorageItem = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error setting ${key} in session storage: ${error}`);
  }
};

// Remove an item from session storage
export const removeSessionStorageItem = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing ${key} from session storage: ${error}`);
  }
};

  export const showError = (error) => {
    if (typeof error === "object") {
      error.map((i) => {
        const errmessage = `${i.field}: ${i.reason}`;
        return triggerSnackbar(errmessage, "warning");
      });
    } else {
      return triggerSnackbar(error, "warning");
    }
  };


  // patterns for pin,aadhar,pan,email,mobile,gst
export const pincodePattern = /^[1-9][0-9]{5}$/; // Regular expression for valid PIN code format
// export const aadharPattern = /^\d{12}$/; // Regular expression for valid Aadhaar card number format
// export const panPattern = /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/; // Regular expression for PAN number format
export const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/; // Regular expression for email format
export const mobilePattern = /^[6-9]\d{9}$/; // Regular expression for valid mobile number format
export const gstPattern =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/; // GST number pattern
export const upiPattern = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;



export async function urlToFile(imageUrl, fileName) {
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  const file = new File([blob], fileName, { type: blob.type });
  return file;
}

export const buildSearchQuery = (o) => {
  let _o = Object.fromEntries(Object.entries(o).filter(([_, v]) => v != null));
  const searchString = new URLSearchParams(_o).toString();
  return searchString && searchString.length ? `?${searchString}` : "";
};

export const trimString = (string, limit = 25) => {
  const trim =
    string && string.length > limit
      ? string.substring(0, limit) + "..."
      : string;
  return trim;
};



export const getDecryptedValue = (value) => {
 
  const bytes = CryptoJS.AES.decrypt(value?.toString(), "thisisasecretkey1234");
  const decryptedValue = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedValue;
};

// Helper function to get image URL - handles both local and Minio/S3 images
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  // If it's already a full URL (starts with http), return as-is
  if (imagePath.startsWith("http")) {
    return imagePath;
  }
  // Otherwise, prepend the ImageUrl
  return ImageUrl + imagePath;
};